import $ from 'jquery';

$(document).ready(function () {
	$(".noUi-handle").on("click", function () {
		$(this).width(50);
	});

	if (document.querySelector('.selects')) {
		let label = document.getElementById('model_category_label');
		let select = label.querySelector('.psuedo_select');
		let options = select.getElementsByClassName('option');

		let blocks = document.getElementsByClassName('maintenance');
		let blockArr = [...blocks];

		[...options].forEach(option => {
			option.addEventListener('click', function (event) {

				blockArr.forEach(block => {
					let value = block.querySelector('.maintenance__model');
					let valueTxt = value.innerText.trim();

					if (valueTxt !== option.innerText) {
						block.classList.add('hidden');
					} else if (valueTxt === option.innerText && block.classList.contains('hidden')) {
						block.classList.remove('hidden');
					}
				})
			});
		});
	}

	$('.open-btn').on('click', function open(event) {
		// const list = $('.maintenance-card__description');
		const list = event.target.previousElementSibling;
		list.classList.contains('closed') ? list.classList.remove('closed') : list.classList.add('closed');
		list.classList.contains('closed') ? event.target.innerText = "Раскрыть список работ" : event.target.innerText = "Скрыть";

		console.log(list);
	})
});